export default function setSidebar(state, action) {
  state.sidebar = {
    ...state.sidebar,
    ...action.payload,
  };
}
